module.exports = __webpack_public_path__ + "static/media/gia.69c54b7c.jpg";